module.exports = __webpack_public_path__ + "static/media/42x42-9.b8d46351.png";